import ui from "./ui";
import { removeClass } from "./utils";
import ogiJson from "../public/ogi_inline.json";

const container = document.createElement("div");
container.id = "container";
container.classList.add("loading");
container.innerHTML = `
<div id="title">
  <img src="./assets/chiba-logo.svg" />
  <h1>中世小城・肥前千葉氏本拠地図</h1>
</div>
<div id="map"></div>
<div id="tab-container">
  <div class="tabs"></div>
  <div class="tab-panes"></div>
</div>
<div id="home-button">
  <a href="./index.html"><img src="./assets/home.svg" /></a>
  <span>ホームに戻る</span>
</div>
<div id="ui">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 119 119"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
    id="move-pans"
  >
    <g transform="matrix(0,1,1,0,59.23,0)">
      <path
        d="M59.23,-59.23C26.518,-59.23 0,-32.712 0,0C0,32.712 26.518,59.23 59.23,59.23C91.942,59.23 118.46,32.712 118.46,0C118.46,-32.712 91.942,-59.23 59.23,-59.23"
        style="fill: rgb(43, 43, 43); fill-rule: nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,59.23,33.293)">
      <path
        d="M0,-22.528L15.894,0L-15.894,0L0,-22.528Z"
        style="fill: rgb(113, 96, 147); fill-rule: nonzero"
        id="panNorth"
        class="pan"
      />
    </g>
    <g transform="matrix(1,0,0,1,107.695,59.23)">
      <path
        d="M0,0L-22.528,15.894L-22.528,-15.894L0,0Z"
        style="fill: rgb(113, 96, 147); fill-rule: nonzero"
        id="panEast"
        class="pan"
      />
    </g>
    <g transform="matrix(1,0,0,1,59.23,85.167)">
      <path
        d="M0,22.528L-15.894,0L15.894,0L0,22.528Z"
        style="fill: rgb(113, 96, 147); fill-rule: nonzero"
        id="panSouth"
        class="pan"
      />
    </g>
    <g transform="matrix(1,0,0,1,10.765,59.23)">
      <path
        d="M0,0L22.528,-15.894L22.528,15.894L0,0Z"
        style="fill: rgb(113, 96, 147); fill-rule: nonzero"
        id="panWest"
        class="pan"
      />
    </g>
  </svg>
</div>
<div id="map-layers"></div>
<div id="notes-modal" class="hidden">
  <div class="header">
  <h2>注釈</h2>
  <button class="close-button">
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2" viewBox="0 0 448 512">
      <path fill="none" d="M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64Z" style="stroke-width:34px" transform="translate(23.005 26.291) scale(.8973)"/>
      <path d="M143 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0 9.3 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9-9.4 9.3-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0-9.3-9.4-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9Z" style="fill-rule:nonzero" transform="translate(23.005 26.291) scale(.8973)"/>
    </svg>
  </button>
  </div>
  <div class="main"></div>
</div>
<div id="textures"></div>
`;

document.body.appendChild(container);

document.addEventListener("DOMContentLoaded", () => {
  removeClass(container, "loading");
});

ui(ogiJson);
